
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1160:711)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34.816 13.496l-2.098 2.097 2.098 2.098-1.398 1.399-2.098-2.099-2.098 2.099-1.398-1.399 2.097-2.098-2.097-2.097 1.398-1.398 2.098 2.097 2.098-2.097 1.398 1.398zM21.778 19.95v3.912h3.11v1.565h-4.666V19.95h1.556zM21 33.82l4.95-4.979a7.055 7.055 0 001.916-3.605 7.08 7.08 0 00-.399-4.069 7.033 7.033 0 00-2.578-3.16 6.971 6.971 0 00-7.778 0 7.033 7.033 0 00-2.578 3.16 7.08 7.08 0 00-.399 4.069 7.055 7.055 0 001.916 3.605l4.95 4.98z","fill":"#F20808"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1160:711","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1160:711"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1160:711","result":"shape"}})])])])
          )
        }
      }
    